import apiHandler from "../core/apiHandler";

/**
 * 📄 API base para exportación PDF
 * de cotizaciones
 *
 * Endpoint:
 * /api/pdf/quotations
 */
const quotationPdfApi =
    apiHandler("pdf/quotations");

export default quotationPdfApi;